export default "__VITE_ASSET__riZOG_5R__"